<template>
    <div class="form-group-scoped">
        <div class="form-item">
            <label class="label-caption">Coordenadas</label>
            <div class="field-label field-label-center">{{ formatarCoordenada(latitude) }} x {{ formatarCoordenada(longitude) }}</div>
        </div>
        <button type="button" class="buttom-icon--map" @click="showMapaModal=true" />
    </div>

    <MapaCoordenadaModal
        :isOpen="showMapaModal"
        :coordenadasIniciais="{ lat: latitude || defLatitude, lng: longitude || defLongitude }"
        :showMarker="!!(latitude && longitude)"
        @close="showMapaModal = false"
        @coordenadaSelecionada="setCoordenadas" />
</template>

  
<script setup>
import { ref, watch } from "vue";
import { globalStore } from "@/globals";
import MapaCoordenadaModal from "./modals/MapaCoordenadaModal.vue";

const props = defineProps({
    modelValueLatitude: Number,
    modelValueLongitude: Number,
});

const emit = defineEmits(["update:modelValueLatitude", "update:modelValueLongitude"]);

const defLatitude = ref(globalStore.latitude || -28.935225);
const defLongitude = ref(globalStore.longitude || -49.485324);
const showMapaModal = ref(false);

const latitude= ref(props.modelValueLatitude || null);
const longitude = ref(props.modelValueLongitude || null);

watch(
    () => [props.modelValueLatitude, props.modelValueLongitude],
    ([newLat, newLng]) => {
        latitude.value = newLat ?? null;
        longitude.value = newLng ?? null;
    }
);

const formatarCoordenada = (valor) => (valor ? parseFloat(valor).toFixed(6) : "--");

const setCoordenadas = (coordenadas) => {
    latitude.value = parseFloat(coordenadas.lat.toFixed(6));
    longitude.value = parseFloat(coordenadas.lng.toFixed(6));

    emit("update:modelValueLatitude", latitude.value);
    emit("update:modelValueLongitude", longitude.value);

    showMapaModal.value = false;
};
</script>

  
<style scoped>
.form-group-scoped {
    align-items: end;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    flex: 1;
}
</style>  